import { UserAuthorityService } from './../../core/services/user-authority.service';
import { Directive, TemplateRef, ViewContainerRef, Input } from '@angular/core';

@Directive({
	selector: '[appViewAccess]'
})
export class ViewAccessDirective {

	permission: string;
	condition: boolean;
	selectedCustomer;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private userAuth: UserAuthorityService
	) { }


	@Input() set appViewAccess(permission: string) {
		if (this.isAuthorized(permission)) {
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			this.viewContainer.clear();
		}
	}

	isAuthorized(permission): boolean {
		if (!permission || permission === 'all') {
			return true;
		}
		return this.userAuth.hasAuthority(permission);
	}

}
